(() => {
  const root = document.documentElement;
  const setScrollState = () => root.classList.toggle('nx-page-scrolled', window.scrollY > 24);
  setScrollState();
  window.addEventListener('scroll', setScrollState, { passive: true });

  document.addEventListener('click', (event) => {
    const dockButton = event.target.closest('[data-nx-dock-action]');
    if (!dockButton) return;
    const action = dockButton.dataset.nxDockAction;
    const selectors = {
      menu: '.header__icon--menu',
      search: '.search-modal__button',
      account: '.account-button',
      cart: 'cart-drawer-component > button[aria-label="カート"], cart-drawer-component > button'
    };
    const trigger = document.querySelector(selectors[action]);
    if (trigger) {
      trigger.click();
    } else if (action === 'account') {
      window.location.assign('/account');
    } else if (action === 'cart') {
      window.location.assign('/cart');
    } else if (action === 'search') {
      window.location.assign('/search');
    }
  });

  document.querySelectorAll('[data-nx-scroll-rail]').forEach((rail) => {
    const wrapper = rail.closest('[data-nx-rail-wrap]');
    if (!wrapper) return;
    wrapper.querySelectorAll('[data-nx-rail-dir]').forEach((button) => {
      button.addEventListener('click', () => {
        const direction = button.dataset.nxRailDir === 'next' ? 1 : -1;
        rail.scrollBy({ left: rail.clientWidth * 0.82 * direction, behavior: 'smooth' });
      });
    });
  });
})();
